import script from "./CardLeito.vue?vue&type=script&setup=true&lang=js"
export * from "./CardLeito.vue?vue&type=script&setup=true&lang=js"

import "./CardLeito.vue?vue&type=style&index=0&id=59526eae&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59526eae"]])

export default __exports__